import { useTranslation } from "react-i18next";
import type { GitProvider } from "../../types/cloud";

interface ProviderCardProps {
  provider: GitProvider;
  onClick: () => void;
}

const PROVIDER_ICONS: Record<string, string> = {
  github: "\uD83D\uDC19",
  gitverse: "\uD83D\uDCE6",
};

export function ProviderCard({ provider, onClick }: ProviderCardProps) {
  const { t } = useTranslation();
  const icon = PROVIDER_ICONS[provider.name] ?? "\uD83D\uDCE6";

  if (!provider.connected) {
    return (
      <div className="bg-[#1a1a1a] border border-[#333] rounded-lg p-6 opacity-50 cursor-not-allowed">
        <div className="flex items-center gap-3 mb-3">
          <span className="text-2xl">{icon}</span>
          <h3 className="text-lg font-semibold text-[#f5f5f5]">{provider.displayName}</h3>
        </div>
        <p className="text-[#666] text-sm mb-4">
          {t('dashboard.provider.signInToImport', { provider: provider.displayName })}
        </p>
        <span className="inline-flex items-center gap-1.5 text-xs text-[#666] px-2 py-1 bg-[#111] rounded">
          {t('dashboard.provider.notConnected')}
        </span>
      </div>
    );
  }

  return (
    <button
      onClick={onClick}
      className="w-full text-left bg-[#1a1a1a] border border-[#333] rounded-lg p-6 hover:border-[#555] transition-colors"
    >
      <div className="flex items-center gap-3 mb-3">
        <span className="text-2xl">{icon}</span>
        <h3 className="text-lg font-semibold text-[#f5f5f5]">{provider.displayName}</h3>
      </div>
      <p className="text-[#999] text-sm mb-4">{t('dashboard.provider.browseRepos')}</p>
      <div className="flex items-center justify-between">
        <span className="inline-flex items-center gap-1.5 text-xs text-green-400 px-2 py-1 bg-green-500/10 rounded">
          {t('dashboard.provider.connected')}
        </span>
        <span className="text-sm text-blue-400 font-medium">{t('dashboard.provider.browseReposAction')} &rarr;</span>
      </div>
    </button>
  );
}
